
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {TradeHistoryRecord} from '../entity/TradeHistoryRecord';
import {FieldModelTradeHistoryRecord} from '../entity/TradeHistoryRecord';

/**
 * TradeHistoryByIdsResult struct
 */
class TradeHistoryByIdsResult {
  /**
   * Initialize struct
   * @param {!Array=} tradeHistory
   * @constructor
   */
  constructor (tradeHistory = []) {
    this.TradeHistory = tradeHistory
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradeHistoryByIdsResult}
   * @param {!TradeHistoryByIdsResult} other Other struct
   * @returns {!TradeHistoryByIdsResult} This struct
   */
  copy (other) {
    if (other.TradeHistory != null) {
      this.TradeHistory = []
      for (let item of other.TradeHistory) {
        if (item != null) {
          let tempItem
          tempItem = TradeHistoryRecord.fromObject(item)
          this.TradeHistory.push(tempItem)
        } else {
          this.TradeHistory.push(null)
        }
      }
    } else {
      this.TradeHistory = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradeHistoryByIdsResult}
   * @returns {!TradeHistoryByIdsResult} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradeHistoryByIdsResultModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradeHistoryByIdsResultModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradeHistoryByIdsResult}
   * @param {!TradeHistoryByIdsResult} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradeHistoryByIdsResult)) {
      throw new TypeError('Instance of TradeHistoryByIdsResult is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradeHistoryByIdsResult}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      TradeHistory: ((this.TradeHistory != null) ? Array.from(this.TradeHistory, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradeHistoryByIdsResult.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradeHistoryByIdsResult} other Object value
   * @returns {!TradeHistoryByIdsResult} Created struct
   */
  static fromObject (other) {
    return new TradeHistoryByIdsResult().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradeHistoryByIdsResult}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradeHistoryByIdsResult.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradeHistoryByIdsResult}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4220
  }
}

export { TradeHistoryByIdsResult };

/**
 * Fast Binary Encoding TradeHistoryByIdsResult field model
 */
class FieldModelTradeHistoryByIdsResult extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.TradeHistory = new fbe.FieldModelVector(new FieldModelTradeHistoryRecord(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.TradeHistory.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.TradeHistory.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradeHistoryByIdsResult.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4220
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.TradeHistory.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TradeHistory.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeHistory.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @param {!TradeHistoryByIdsResult} fbeValue Default value, defaults is new TradeHistoryByIdsResult()
   * @returns {!TradeHistoryByIdsResult} TradeHistoryByIdsResult value
   */
  get (fbeValue = new TradeHistoryByIdsResult()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @param {!TradeHistoryByIdsResult} fbeValue TradeHistoryByIdsResult value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.TradeHistory.fbeSize) <= fbeStructSize) {
      this.TradeHistory.get(fbeValue.TradeHistory)
    } else {
      fbeValue.TradeHistory.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeHistory.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @param {!TradeHistoryByIdsResult} fbeValue TradeHistoryByIdsResult value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradeHistoryByIdsResult}
   * @param {TradeHistoryByIdsResult} fbeValue TradeHistoryByIdsResult value
   */
  setFields (fbeValue) {
    this.TradeHistory.set(fbeValue.TradeHistory)
  }
}

export { FieldModelTradeHistoryByIdsResult };

/**
 * Fast Binary Encoding TradeHistoryByIdsResult model
 */
class TradeHistoryByIdsResultModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradeHistoryByIdsResult(this.buffer, 4)
  }

  /**
   * Get the TradeHistoryByIdsResult model
   * @this {!TradeHistoryByIdsResultModel}
   * @returns {!FieldModelTradeHistoryByIdsResult} model TradeHistoryByIdsResult model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradeHistoryByIdsResultModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradeHistoryByIdsResultModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradeHistoryByIdsResultModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradeHistoryByIdsResultModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradeHistoryByIdsResult.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradeHistoryByIdsResultModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradeHistoryByIdsResultModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradeHistoryByIdsResultModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradeHistoryByIdsResultModel}
   * @param {!TradeHistoryByIdsResult} value TradeHistoryByIdsResult value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradeHistoryByIdsResultModel}
   * @param {!TradeHistoryByIdsResult} value TradeHistoryByIdsResult value, defaults is new TradeHistoryByIdsResult()
   * @return {!object} Deserialized TradeHistoryByIdsResult value and its size
   */
  deserialize (value = new TradeHistoryByIdsResult()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradeHistoryByIdsResult(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradeHistoryByIdsResult(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradeHistoryByIdsResultModel}
   * @param {!number} prev Previous TradeHistoryByIdsResult model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradeHistoryByIdsResultModel };
